import { Button, Col, Input, Radio, Row } from 'antd';
import React, { Component } from 'react';
import { SORT_ITEM_BY } from './../../../../../constants';
import './styles.css';

const RadioGroup = Radio.Group

class AddFilter extends Component {
    onChange = (e) => {
        this.props.onFilterChange(e)
    }

    onResetFilter = () => {
        this.props.onResetFilter()
    }

    onKeyDown = (e) => {
        if (e.keyCode === 13) {
            document.getElementById('apply-filter-item-name').click()
        }
    }

    render() {
        const { sku, itemCode, itemNameEn, itemNameJp, countryOfOrigin, OrderBy } = this.props.filterValues
        const { isFilterVisible } = this.props

        if (!isFilterVisible) return null

        return (
            <Col span={24}>
                <div className="item-name-filter">
                    <Row>
                        <Col span={3}>
                            <h3>Add Filters</h3>
                        </Col>
                        <Col span={1} offset={20}>
                            <span className='close-filter'
                                style={{ float: 'right', cursor: 'pointer' }}
                                onClick={this.props.toggleFilter}>X</span>
                        </Col>
                    </Row>
                    <Row gutter={16} type="flex">
                        <Col span={24}>
                            <Row gutter={16}>
                                <Col span={3}>
                                    <div className="filter-title">
                                        <span>SKU</span>
                                    </div>
                                    <div className="filter-channel filter-status">
                                        <Input
                                            name="sku"
                                            value={sku}
                                            size="small"
                                            onChange={this.onChange}
                                            onKeyDown={e => this.onKeyDown(e)}
                                        />
                                    </div>
                                </Col>
                                <Col span={4}>
                                    <div className="filter-title">
                                        <span>CHANNEL ITEM CODE</span>
                                    </div>
                                    <div className="filter-channel-orders">
                                        <Input
                                            name="itemCode"
                                            value={itemCode}
                                            size="small"
                                            onChange={this.onChange}
                                            onKeyDown={e => this.onKeyDown(e)}
                                        />
                                    </div>
                                </Col>
                                <Col span={5}>
                                    <div className="filter-title">
                                        <span>ITEM NAME-EN</span>
                                    </div>
                                    <div className="filter-channel-orders">
                                        <Input
                                            name="itemNameEn"
                                            value={itemNameEn}
                                            size="small"
                                            onChange={this.onChange}
                                            onKeyDown={e => this.onKeyDown(e)}
                                        />
                                    </div>
                                </Col>
                                <Col span={8}>
                                    <div className="filter-title">
                                        <span>ITEM NAME-JP</span>
                                    </div>
                                    <div className="filter-channel-orders">
                                        <Input
                                            name="itemNameJp"
                                            value={itemNameJp}
                                            size="small"
                                            onChange={this.onChange}
                                            onKeyDown={e => this.onKeyDown(e)}
                                        />
                                    </div>
                                </Col>
                                <Col span={4} style={{width:'64px'}}>
                                    <div className="filter-title">
                                        <span>ORIGIN</span>
                                    </div>
                                    <div className="filter-channel-orders">
                                        <Input
                                            name="countryOfOrigin"
                                            value={countryOfOrigin}
                                            size="small"
                                            onChange={this.onChange}
                                            onKeyDown={e => this.onKeyDown(e)}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={3}>
                                    <div className="filter-title sort-filter">
                                        <span>SORT ITEMS BY</span>
                                    </div>
                                    <div className="filter-channel-orders">
                                        <RadioGroup
                                            name="OrderBy"
                                            value={OrderBy}
                                            onChange={this.onChange}
                                        >
                                            <Radio value={SORT_ITEM_BY.SKU}>SKU</Radio>
                                            <Radio value={SORT_ITEM_BY.CreatedDT_DESC}>Date Added (Newest to Oldest)</Radio>
                                            <Radio value={SORT_ITEM_BY.CreatedDT}>Date Added (Oldest to Newest)</Radio>
                                        </RadioGroup>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="btn-action">
                        <Col span={6} offset={9}>
                            <Button
                                htmlType="reset"
                                className="clear"
                                size="large"
                                onClick={this.onResetFilter}
                            >Reset</Button>
                            <Button
                                htmlType="submit"
                                className="display ant-btn-primary"
                                size="large"
                                id='apply-filter-item-name'
                                onClick={this.props.onApplyFilter}
                            >Apply</Button>
                        </Col>
                    </Row>
                </div>
            </Col>
        )
    }
}

export default AddFilter



// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/filter/index.js